// extracted by mini-css-extract-plugin
export var searchHeader = "_9i-0";
export var searchHeaderDark = "_9i-1";